import { getErrorMessage } from "@/helpers/handleErrorResponse";
import type {
  GetOnboardingModulesResponse,
  GetOnboardingProgressResponse,
  PutOnboardingProgressBody,
  PutOnboardingProgressResponse
} from "@/types/onboarding";
import { CustomError } from "@/utils/errors";

import axiosInstance from "../config";

export const getOnboardingModules =
  async (): Promise<GetOnboardingModulesResponse> => {
    try {
      const { data } = await axiosInstance.get<GetOnboardingModulesResponse>(
        "/v1/onboarding/modules"
      );
      return data;
    } catch (error) {
      const { status, message } = getErrorMessage(error);
      throw new CustomError(message, status);
    }
  };

export const getOnboardingProgress = async (
  moduleId?: string
): Promise<GetOnboardingProgressResponse> => {
  try {
    const { data } = await axiosInstance.get("/v1/onboarding/progress", {
      params: moduleId ? { module_id: moduleId } : undefined
    });
    return data as GetOnboardingProgressResponse;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};

export const putOnboardingProgress = async (
  moduleId: string,
  body: PutOnboardingProgressBody
): Promise<PutOnboardingProgressResponse> => {
  try {
    const { data } = await axiosInstance.put(
      `/v1/onboarding/progress/${moduleId}`,
      body
    );
    return data as PutOnboardingProgressResponse;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    throw new CustomError(message, status);
  }
};
